export enum ActionNames {
  Commentary = 'Commentary',
  TopStory = 'Top Story',
  FeaturedStory = 'Featured Story',
  NonQualifiedSubject = 'Non Qualified Subject',
  PublishedSelectected = 'Published Selected',
}
